/**
 * Wudy Kitchen — Static Pages JS (Dalga 2)
 * Reuses Journal V3 IntersectionObserver pattern
 * Adds: FAQ accordion, policy TOC active tracking
 */
(function () {
  'use strict';

  function isFooterPageMobile() {
    var body = document.body;
    var isPageish =
      body.classList.contains('template-page') ||
      body.classList.contains('template-policy') ||
      !!document.querySelector('.wkn-page, .wpr-reviews, .wp-faq, .wp-contact, .wp-policy, .wp-hero');
    // If a leaked PDP script mislabeled the body, still treat real page content as a page.
    if (body.classList.contains('template-product') && document.querySelector('.wkn-page, .wp-hero')) {
      isPageish = true;
    }
    return isPageish && window.matchMedia('(max-width: 749px)').matches;
  }

  function prefersSmoothScroll() {
    return (
      window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  /* ── 1. Reveal animations (shared with journal-v3) ── */
  function initRevealObserver() {
    var targets = document.querySelectorAll(
      '.wp-hero__eyebrow, .wp-hero__title, .wp-hero__deck, ' +
      '.wp-reveal, .wp-value-card'
    );
    if (!targets.length) return;

    if (isFooterPageMobile()) {
      targets.forEach(function (el) {
        el.classList.add('is-revealed');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });

    targets.forEach(function (el) { observer.observe(el); });
    // Failsafe: never leave page content invisible (carousel / threshold misses)
    setTimeout(function () {
      targets.forEach(function (el) {
        if (!el.classList.contains('is-revealed')) el.classList.add('is-revealed');
      });
    }, 1800);
  }

  /* ── 2. Hero load sequence ── */
  function initHeroLoad() {
    var hero = document.querySelector('.wp-hero');
    if (!hero) return;
    if (isFooterPageMobile()) {
      hero.querySelectorAll('.wp-hero__eyebrow, .wp-hero__title, .wp-hero__deck').forEach(function (el) {
        el.classList.add('is-revealed');
      });
      return;
    }
    setTimeout(function () {
      var eyebrow = hero.querySelector('.wp-hero__eyebrow');
      var title   = hero.querySelector('.wp-hero__title');
      var deck    = hero.querySelector('.wp-hero__deck');
      if (eyebrow) eyebrow.classList.add('is-revealed');
      setTimeout(function () { if (title) title.classList.add('is-revealed'); }, 150);
      setTimeout(function () { if (deck)  deck.classList.add('is-revealed');  }, 400);
    }, 300);
  }

  /* ── 3. FAQ Accordion ── */
  function initAccordion() {
    var items = document.querySelectorAll('.wp-accordion-item');
    if (!items.length) return;

    items.forEach(function (item) {
      var trigger = item.querySelector('.wp-accordion-trigger');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        // Close all
        items.forEach(function (i) { i.classList.remove('is-open'); });

        // Toggle current
        if (!isOpen) {
          item.classList.add('is-open');
        }
      });
    });

    // Open first item by default
    if (items[0]) items[0].classList.add('is-open');
  }

  /* ── 4. Policy TOC: active section tracking ── */
  function initPolicyToc() {
    var tocLinks = document.querySelectorAll('.wp-policy__toc-link[href^="#"]');
    if (!tocLinks.length) return;

    var sections = [];
    tocLinks.forEach(function (link) {
      var id = link.getAttribute('href').slice(1);
      var section = document.getElementById(id);
      if (section) sections.push({ link: link, section: section });
    });

    var ticking = false;
    function updateActive() {
      var scrollY = window.scrollY + 120;
      var active = null;
      sections.forEach(function (s) {
        if (s.section.offsetTop <= scrollY) active = s;
      });
      tocLinks.forEach(function (l) { l.classList.remove('is-active'); });
      if (active) active.link.classList.add('is-active');
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        updateActive();
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    updateActive();
  }

  /* ── 5. Smooth TOC anchors ── */
  function initTocAnchors() {
    document.querySelectorAll('.wp-policy__toc-link[href^="#"]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        var target = document.querySelector(el.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: prefersSmoothScroll() ? 'smooth' : 'instant',
            block: 'start',
          });
        }
      });
    });
  }

  /* ── 6. Track order form (delegates to existing 17track widget or Shopify order status) ── */
  function initTrackForm() {
    var form = document.getElementById('wp-track-form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var orderNum = document.getElementById('wp-order-number');
      if (!orderNum || !orderNum.value.trim()) return;
      // Redirect to Shopify order status page
      window.location.href = '/account/orders';
    });
  }

  /* ── Init ── */
  function init() {
    initRevealObserver();
    initHeroLoad();
    initAccordion();
    initPolicyToc();
    initTocAnchors();
    initTrackForm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
